import {Component, OnInit, ViewContainerRef, Renderer2, Input} from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { LookupViewModel } from '../../view-models/lookup.view-model';
import { NdmsValidators } from '../ndmsValidators.validators';

@Component({
  selector: 'ndms-wristband',
  templateUrl: './ndms-wristband.component.html',
  styleUrls: ['./ndms-wristband.component.scss']
})
export class NdmsWristbandComponent extends NdmsFormControlComponent implements OnInit {
  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  ngOnInit() {
    //if(console) console.log("wristband",this.group);
    (<FormGroup>this.group.controls.identifier).controls.identifierNumber.setValidators([NdmsValidators.noSpace]);
  }

  canAddArrayItem(currentIndex: number) {
    return true;
  }

  compareFn(c1: LookupViewModel, c2: LookupViewModel): boolean {
    return c1 && c2 ? c1.key === c2.key : c1 === c2;
  }
}
